// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2cxDi","content":"RecentSearches_content__34gto"};